import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const usePayment = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getPaymentsByBookingId = async bookingId => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/payment/by/booking/${bookingId}`,
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const convertToOfflinePaymentSilent = async paymentId => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/payment/${paymentId}/convertToOfflineSilent`,
          method: 'POST',
          headers: authCtx.getAuthHeaders(),
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const cancelPaymentsSilent = async paymentId => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/payment/${paymentId}/cancelSilent`,
          method: 'POST',
          headers: authCtx.getAuthHeaders(),
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  return {
    isLoading,
    error,
    getPaymentsByBookingId,
    convertToOfflinePaymentSilent,
    cancelPaymentsSilent,
  };
};

export default usePayment;
